// workaround for webpack and sass loader multiple imports
import colors from '../../scss/variables.scss?vue&type=style&index=0&lang=scss&module=1'

export default colors;
